import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdatePartner from '@/modules/manage-player/api/hooks/useMutationUpdatePartner'
import { GetPartnerDataResponse } from '@/modules/manage-player/type'
import { useQueryClient } from '@tanstack/react-query'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'

interface IsActiveToggleProps {
	row: GetPartnerDataResponse
}

export default function IsActiveToggle({ row }: IsActiveToggleProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updatePartner } = useMutationUpdatePartner()

	const handleMutate = async (value: boolean) => {
		await updatePartner({
			id: row.id,
			payload: { isActive: value },
		})
		// Invalidate partner queries to refresh the data
		queryClient.invalidateQueries({
			queryKey: [PartnerQueryKeys.GetPartners],
		})
		queryClient.invalidateQueries({
			queryKey: [PartnerQueryKeys.GetPartnerById],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isActive}
			onMutate={handleMutate}
			successMessage={
				row.isActive
					? 'ปิดใช้งานพาร์ทเนอร์สำเร็จ'
					: 'เปิดใช้งานพาร์ทเนอร์สำเร็จ'
			}
		/>
	)
}
